<template>
  <el-form ref="ruleFormRef" :model="appointmentForm" :rules="appointmentRules" label-width="120px"
    class="demo-ruleForm" :size="formSize" status-icon>
    <!-- 预约日期 -->
    <el-form-item label="预约日期" prop="appointmentDate">
      <el-date-picker v-model="appointmentForm.appointmentDate" :disabled-date="disabledDate"
        autocomplete="new-password" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="请选择预约日期" />
    </el-form-item>

    <!-- 预约时段 -->
    <el-form-item label="预约时段" prop="appointmentTime">
      <div style="display: flex; align-items: center; gap: 8px;">
        <el-time-select v-model="appointmentForm.startTime" :max-time="appointmentForm.endTime" placeholder="开始时间"
          start="08:30" step="00:30" end="18:30" @change="validateTimeRange" />
        <span>-</span>
        <el-time-select v-model="appointmentForm.endTime" :min-time="appointmentForm.startTime" placeholder="结束时间"
          start="08:30" step="00:30" end="18:30" @change="validateTimeRange" />
      </div>
    </el-form-item>

    <!-- 预约限制人数 -->
    <el-form-item label="预约限制人数" prop="limitNum">
      <el-input v-model.number="appointmentForm.limitNum" type="number" min="1" placeholder="请输入预约限制人数" />
    </el-form-item>

    <!-- 理发地点 -->
    <el-form-item label="理发地点" prop="remark">
      <el-input v-model="appointmentForm.remark"  placeholder="请输入理发地点" />
    </el-form-item>
    <el-form-item label="经度" prop="longitude">
      <el-input v-model="appointmentForm.longitude"  placeholder="请输入经度" />
    </el-form-item>
    <el-form-item label="纬度" prop="latitude">
      <el-input v-model="appointmentForm.latitude"  placeholder="请输入纬度" />
    </el-form-item>

    <!-- 操作按钮 -->
    <el-form-item>
      <el-button type="primary" size="default" @click="submitForm">
        保存
      </el-button>
      <el-button size="default" @click="closeForm">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { reactive, ref, defineEmits, defineExpose, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import service from "@/http/request.js";

// 表单尺寸
const formSize = ref("default");

// 自定义事件
const emit = defineEmits(["dialogClose"]);

// 表单ref
const ruleFormRef = ref();

// 理发地点下拉选项（可根据实际接口返回赋值）
const addressOptions = ref([
  
]);

// 预约表单数据（字段名改为规范英文名）
const appointmentForm = reactive({
  appointmentDate: null,    // 预约日期
  startTime: null,          // 开始时间
  endTime: null,            // 结束时间
  appointmentTime: "",      // 拼接后的预约时段（传给后端）
  remark: null,  // 理发地点
  limitNum: null      // 预约限制人数
});

// 禁用过去的日期（只能选今天及以后）
const disabledDate = (time) => {
  return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000;
};

// 校验预约时段（确保开始/结束时间都选择）
const validateTimeRange = () => {
  if (appointmentForm.startTime && appointmentForm.endTime) {
    appointmentForm.appointmentTime = `${appointmentForm.startTime}-${appointmentForm.endTime}`;
  } else {
    appointmentForm.appointmentTime = "";
  }
};

// 表单校验规则（4个字段都必填）
const appointmentRules = reactive({
  appointmentDate: [
    {
      required: true,
      message: "请选择预约日期",
      trigger: ["change", "blur"],
    },
  ],
  appointmentTime: [
    {
      required: true,
      message: "请选择完整的预约时段（开始+结束时间）",
      trigger: ["change", "blur"],
    },
  ],
  remark: [
    {
      required: true,
      message: "请输入理发地点",
      trigger: ["change", "blur"],
    },
  ],
  limitNum: [
    {
      required: true,
      message: "请输入预约限制人数",
      trigger: ["change", "blur"],
    },
    {
      type: "number",
      min: 1,
      message: "预约限制人数不能小于1",
      trigger: ["change", "blur"],
    }
  ]
});

// 初始化表单（编辑场景回显数据）
const init = (row) => {
  // 清空原有数据
  Object.keys(appointmentForm).forEach(key => {
    appointmentForm[key] = null;
  });
  delete appointmentForm.id;

  if (row) {
    // 回显基础字段
    appointmentForm.appointmentDate = row.appointmentDate || null;
    appointmentForm.remark = row.remark || null;
    appointmentForm.limitNum = row.limitNum ? Number(row.limitNum) : null;
    appointmentForm.id = row.id || null;
    appointmentForm.latitude = row.latitude || null;
    appointmentForm.longitude = row.longitude || null;

    // 拆分预约时段（如果后端返回的是hh:mm-hh:mm格式）
    if (row.appointmentTime) {
      const [start, end] = row.appointmentTime.split("-");
      appointmentForm.startTime = start || null;
      appointmentForm.endTime = end || null;
      appointmentForm.appointmentTime = row.appointmentTime;
    }
    console.log(appointmentForm);
    
  }
};

// 暴露初始化方法给父组件
defineExpose({ init });

// 提交表单
const submitForm = async () => {
  if (!ruleFormRef.value) return;

  // 先校验时段拼接
  validateTimeRange();

  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      try {
        // 构造传给后端的参数（只传需要的字段，拼接好时段）
        const submitData = {
          appointmentDate: appointmentForm.appointmentDate,
          appointmentTime: appointmentForm.appointmentTime, // hh:mm-hh:mm格式
          remark: appointmentForm.remark,
          limitNum: appointmentForm.limitNum,
          longitude: appointmentForm.longitude,
          latitude: appointmentForm.latitude,
        };
        if (appointmentForm.id) {
          submitData.id = appointmentForm.id;
        }
        let url = appointmentForm.id ? '/health/web/appointmentInfo/update' : '/health/web/appointmentInfo/add';
        service.post(url, submitData)
          .then(data => {
            console.log(data)
            if (data.data.code == 200) {
              ElMessage.success("预约信息保存成功！");
              emit("dialogClose", true); // 通知父组件关闭弹窗并刷新
            } else {
              ElMessage.error(res.data.msg || "保存失败，请重试");
            }
          })
          .catch(err => {
            ElMessage({
              message: err.message,
              type: "error",
            });
          })
      } catch (error) {
        console.error("提交失败：", error);
        ElMessage.error("网络异常，保存失败");
      }
    } else {
      console.log("表单校验失败：", fields);
      ElMessage.warning("请完善必填字段后再提交");
    }
  });
};

// 关闭表单
const closeForm = () => {
  // 重置表单
  if (ruleFormRef.value) {
    ruleFormRef.value.resetFields();
  }
  emit("dialogClose");
};

// 挂载时初始化（如果有地址接口，可在这里调用）
onMounted(() => {
  // 示例：如果需要从接口获取理发地点选项
  // getBarberShopList().then(res => {
  //   addressOptions.value = res.data || [];
  // });
});
</script>

<style scoped>
.demo-ruleForm {
  padding: 16px 0;
}
</style>